import { defineStore } from 'pinia';

export const useComponentStatusStore = defineStore('componentStatus', {
  state: () => ({
    isMounted: false,
    objLoaded: false
  }),
  actions: {
    setMounted(value: boolean) {
      this.isMounted = value;
    },
    setObjLoaded(value: boolean){
      this.objLoaded = value;
    }
  },
});

